export default __webpack_public_path__ + "static/bestPracticeBg-cac6d75862541020bb297fd15f20f0b9.png";